<p-toast class="freya-toast">
    <ng-template
        let-message
        pTemplate="message"
    >
        <span [class]="'p-toast-message-icon pi ' + message.icon"></span>
        <div class="p-toast-message-text">
            <div class="p-toast-summary">
                {{ message.summary }}
            </div>
            <div class="p-toast-detail">
                {{ message.detail }}
                <div
                    *ngIf="message.data?.buttons"
                    class="button-container"
                >
                    <button
                        *ngFor="let button of message.data.buttons"
                        pButton
                        [label]="button?.label"
                        [icon]="button?.icon"
                        [class]="button?.styleClass"
                        (click)="button?.onClick"
                        [routerLink]="button?.routerLink"
                    ></button>
                </div>
                <div
                    *ngIf="message.severity === 'error' && getSupportType(message) === 'support'"
                    class="button-container p-mt-2"
                >
                    <button
                        *ngIf="message.severity === 'error'"
                        pButton
                        label="Report Bug"
                        icon="pi pi-send"
                        class="p-button-danger"
                        (click)="reportBug(message)"
                    ></button>
                </div>
                <div
                    *ngIf="message.severity === 'error' && getSupportType(message) === 'accounting'"
                    class="button-container p-mt-2"
                >
                    <button
                        *ngIf="message.severity === 'error'"
                        pButton
                        [label]="contactAccountingButtonText"
                        icon="pi pi-send"
                        class="p-button-danger"
                        (click)="contactAccounting(message)"
                    ></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>

<router-outlet *ngIf="(appLoadingService.appLoading | async) === false"></router-outlet>
<app-loading-skeleton
    *ngIf="(appLoadingService.appLoading | async) === true && !appLoadingService.error"></app-loading-skeleton>
<app-error *ngIf="(appLoadingService.appLoading | async) === true && appLoadingService.error && isOnline">
    {{ appLoadingService.error }}
</app-error>

<app-offline *ngIf="!isOnline">
</app-offline>


<p-dialog
    header="Update Available"
    [visible]="updateService.showNewVersionModal"
    [modal]="true"
>
    <p>A new version of Move Right is available! <a href="/releases" target="_blank" rel="noopener" style="color: var(--primary-color); text-decoration: underline;">See what's new</a></p>
    <ng-template pTemplate="footer">
        <button
            pButton
            class="p-button-success"
            label="Snooze 10 minutes"
            icon="pi pi-times"
            (click)="updateService.dismissVersionUpdate()"
        ></button>
        <button
            pButton
            class="p-button-success"
            label="Update Now"
            [disabled]="updateService.updating"
            icon="pi pi-refresh"
            (click)="updateService.updateApplication()"
        ></button>
    </ng-template>
</p-dialog>

<app-cancel-and-close-dialog></app-cancel-and-close-dialog>
<app-mutate-container *ngIf="plusAuth.user?.id && mutateContainerEnabled"></app-mutate-container>
<app-create-transaction-dialog
    *ngIf="plusAuth.user?.id"
></app-create-transaction-dialog>
<app-create-document-dialog
    *ngIf="plusAuth.user?.id"
></app-create-document-dialog>
<app-cancel-pay-link-dialog
    *ngIf="plusAuth.user?.id"
></app-cancel-pay-link-dialog>
<app-cancel-preauth-dialog
    *ngIf="plusAuth.user?.id"
></app-cancel-preauth-dialog>
<app-artifact-dialog></app-artifact-dialog>

<p-confirmDialog
    [breakpoints]="{'992px': '62vw', '510px': '93vw'}"
    [style]="{width: '50vw'}"
    [baseZIndex]="10000"
></p-confirmDialog>
